import { laptopSmallMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const PointsGroup = styled.div`
  display: flex;
  margin: 30px 0 60px;
  justify-content: space-between;

  @media (${laptopSmallMax}) {
    flex-direction: column;
  }
`;

export const Point = styled.div`
  display: flex;
  flex: 1;
  max-width: 31%;

  @media (${laptopSmallMax}) {
    margin: 15px 0;
    max-width: none;
  }
`;

export const IconBox = styled.div`
  width: 50px;
  margin-right: 20px;
`;

export const Circle = styled.div`
  width: 60px;
  height: 60px;
  padding: 0 5px;
  border-radius: 50%;
  line-height: 57px;
  text-align: center;
  font-size: 40px;
  font-weight: 800;
  color: #fff;
  background-color: #ee4900;
`;
